import React, { Component } from 'react';
import lottie from 'lottie-web';
import loaderLottie from './loader-lottie.json';

const defaultSize = '100px';

class LottieLoader extends Component {

    componentDidMount() {
        this.animation = lottie.loadAnimation({
            container: this.animationContainer,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: loaderLottie,
        });
    }

    componentWillUnmount() {
        if (this.animation) {
            this.animation.destroy();
        }
    }

    render() {
        return <div
                style={{width: this.props.size || defaultSize, height: this.props.size || defaultSize}}
                ref={(ref) => (this.animationContainer = ref)} />;
    }
}

export default LottieLoader;
